import { jsx as _jsx } from "react/jsx-runtime";
import { DebugBoundary } from "@sail/observability";
import { memo, useCallback, useContext } from "react";
import KillSwitchContext from "../../internal/killswitch/KillSwitchContext";
export default /*#__PURE__*/ memo(function KillSwitch({ id, children, fallback = null }) {
    const [killedIds] = useContext(KillSwitchContext);
    const isKilled = useCallback((componentId)=>killedIds.has(componentId), [
        killedIds
    ]);
    if (isKilled(id)) {
        return fallback;
    }
    return /*#__PURE__*/ _jsx(DebugBoundary, {
        category: "KillSwitch",
        name: id,
        color: "#B91C1C",
        children: children
    });
});

//# sourceMappingURL=KillSwitch.js.map